module.exports = __webpack_public_path__ + "img/img-main-bg02.2d7c84cd.png";